<template>
  <div
    class="proj-manage-box"
    v-if="isChecked('Project.Single.List')">
    <transition
      enter-active-class="animate__animated animate__fadeInDown"
      leave-active-class="animate__animated animate__fadeOutUp"
      :duration="{ enter: 300, leave: 300 }">
      <div
        class="expiredTitle"
        v-if="showExpired">
        <div>
          <i class="el-icon-warning"></i>
          <span
            >您的账户试用期已结束。可前往
            <span
              class="expiredTitle-link"
              @click="getBuyOrder"
              >购买套餐</span
            >选择合适的套餐继续使用我们的服务。</span
          >
        </div>
        <i
          class="el-icon-close"
          @click="closeExpired"></i>
      </div>
    </transition>
    <div class="header-box">
      <!-- <div class="title-box">项目管理({{ projTotal }})</div> -->
      <PageTitle
        :title="`项目管理${projTotal ? `(${projTotal})` : ''}`"
        :titleStyle="{
          color: `var(--home-content-title-color)`,
          fontSize: '18px'
        }"
        :iconInfo="{
          icon: 'icon-xiangmuguanli',
          iconPadding: '10px',
          color: 'var(--base-primary-bgColor)',
          bgColor: 'var(--base-bg-light-color24)',
          iconRadius: '50%'
        }" />
      <div class="operation-box search-box">
        <div
          class="item-box gr16"
          v-if="isChecked('Project.Single.List')">
          <div class="label-box search-box-title">项目来源</div>
          <div class="common-select-box search-box-title-input">
            <el-select
              size="small"
              class="primary-select"
              v-model="projSource"
              @change="switchProjSource"
              :popper-append-to-body="false">
              <el-option
                v-for="item in projSourceList"
                :key="item.value"
                :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
        </div>
        <div
          class="item-box gr16"
          v-if="isChecked('Project.Single.List')">
          <div class="common-input-box search-box-title-input">
            <el-input
              size="small"
              class="input-primary"
              v-model="keywords"
              placeholder="请输入项目名称"
              clearable
              @clear="searchProj"
              @keyup.enter.native="searchProj">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="searchProj" />
            </el-input>
          </div>
        </div>
        <div
          class="item-box"
          v-if="isChecked('Project.Single.Create')">
          <div class="common-button-box">
            <el-button
              class="create-btn search-box-title-btn primary-btn"
              type="primary"
              @click="openCreateProjDialog">
              创建项目
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="proj-list-box">
      <div v-if="loading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)" />
      </div>
      <div
        v-if="!loading && !isEmpty"
        class="data-box">
        <div
          class="list-box"
          :infinite-scroll-delay="150"
          :infinite-scroll-distance="20"
          :infinite-scroll-immediate="false"
          v-infinite-scroll="handleScroll">
          <div
            class="list-item-box"
            v-for="(item, index) in projList"
            :key="index">
            <div
              class="thumbnail-box"
              @click="viewProj(item)">
              <div class="time-info-box">
                <div class="time-info-box-text">
                  <div>创建日期：{{ formatTime(item.creationTime) }}</div>
                  <div>更新日期：{{ getUpdateTime(item) }}</div>
                </div>
              </div>
              <img
                v-if="item.thumbnail"
                :src="getProjThumbnail(item)"
                @error="showDefaultImg" />
              <img
                v-else
                :src="getDefaultThumbnail()" />
            </div>
            <!-- <div class="delete-btn-box" v-if="isChecked('Project.Single.Delete')">
              
            </div> -->
            <div
              class="symbol-box share"
              v-if="item.projectShareType === 1">
              <div class="text-box">分享</div>
            </div>
            <div
              v-if="item.projectShareType === 2"
              class="symbol-box demo">
              <div class="text-box">示例</div>
            </div>

            <div class="proj-info-box">
              <div
                class="text-overflow"
                :title="item.projName">
                <span class="base-name base-fontsize-16 base-name-box">
                  <span @click="viewProj(item)">
                    {{ item.projName }}
                  </span>
                </span>
                <div class="dropSelect">
                  <el-dropdown trigger="click">
                    <div class="el-dropdown-link icon-btn">
                      <i class="el-icon el-icon-more"></i>
                    </div>
                    <el-dropdown-menu
                      slot="dropdown"
                      class="dropdown-primary dropSelect-item">
                      <el-dropdown-item>
                        <el-button
                          type="text"
                          :disabled="!isChecked('Project.Single.Delete')"
                          @click="e => deleteProjConfirm(item.projId, e)"
                          >删除</el-button
                        >
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div
                v-if="!baiduDisabled"
                class="location-info-box">
                <!-- <i class="el-icon-location-outline" /> -->
                <div class="city-name base-fontsize-14">
                  {{ item.location?.cityName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="common-empty-box"
        v-if="!loading && isEmpty">
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <div class="description empty-text">抱歉，没有找到相关内容</div>
          </template>
          <!-- <div class="common-button-box">
            <el-button
              v-if="!isNoFindProj()"
              size="small"
              type="primary"
              @click="openCreateProjDialog">
              创建项目
            </el-button>
          </div> -->
        </bj-empty>
      </div>
    </div>
    <CreateProjDialog
      :visible="isCreateProjDialogVisible"
      :closeDialog="closeCreateProjDialog"
      :refreshProjList="refreshProjList" />
    <DragDialog
      title="名称验证"
      :visible.sync="isNameValidateDialogVisible"
      :footerBtn="['cancel', 'submit']"
      :submit="submitDelete"
      :cancel="closeNameValidateDialog">
      <el-input
        :maxlength="30"
        show-word-limit
        v-model="projNameInput"
        placeholder="请输入项目名称" />
    </DragDialog>
    <!-- <personInfoPop /> -->
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import DragDialog from '@/components/CustomDragDialog.vue'
import CreateProjDialog from '@/components/CreateProject.vue'
import PageTitle from '@/components/pageComponents/pageTitle.vue'
import { Store } from '@/utils/store'
import EventBus from '@/utils/eventBus'
import { dataTypeList } from '@/utils/dictionary'
import { formatTime, getTokenId, exitSystem } from '@/utils/generalMethods'
import { TokenManager } from '@/utils/tokenManage'
// import personInfoPop from '@/layout/personInfoPop.vue'

import {
  getProjListService,
  getDemoProjTokenService,
  refreshTokenService,
  getRoleMenu,
  deleteProjService
} from '@/service/interface'

export default {
  data() {
    return {
      loading: false,
      currPage: 1,
      pageSize: 20,
      isAllProjLoaded: false,
      projTotal: 0,
      projList: [],

      projSource: undefined,
      projSourceList: [
        { label: '所有', value: undefined },
        { label: '我的', value: 0 },
        { label: '他人分享', value: 1 }
      ],
      keywords: '',

      baiduDisabled: window.baiduDisabled,

      isEmpty: false,

      isCreateProjDialogVisible: false,

      projIdToDelete: '',
      isNameValidateDialogVisible: false,
      projNameInput: '',
      showExpired: false
    }
  },
  components: {
    Spin,
    DragDialog,
    CreateProjDialog,
    PageTitle
  },
  mounted() {
    this.initProjList()

    EventBus.$on('changeTheme', this.refreshProjList)
    EventBus.$on('getSubInfo', val => {
      const flag = localStorage.getItem('subInfoFlag')
      if (!val.noneSubscribe && !val.trialing && !val.subscribing) {
        if (flag !== null) {
          this.showExpired = false
        } else {
          this.showExpired = true
        }
      } else {
        this.showExpired = false
      }
    })
  },
  methods: {
    initProjList() {
      this.loading = true
      this.queryProjList().then(projList => {
        if (!projList.length) {
          this.isEmpty = true
        } else {
          this.projList = projList
          this.isEmpty = false
        }

        this.loading = false
      })
    },
    getBuyOrder() {
      this.$router.push('/purchasePackage')
    },
    closeExpired() {
      this.showExpired = false
      localStorage.setItem('subInfoFlag', 'false')
    },
    switchProjSource() {
      this.isAllProjLoaded = false
      this.currPage = 1

      this.loading = true
      this.queryProjList().then(projList => {
        if (!projList.length) {
          this.isEmpty = true
        } else {
          this.projList = projList
          this.isEmpty = false
        }

        this.loading = false
      })
    },
    searchProj() {
      this.isAllProjLoaded = false
      this.currPage = 1

      this.loading = true
      this.queryProjList().then(projList => {
        if (!projList.length) {
          this.isEmpty = true
        } else {
          this.projList = projList
          this.isEmpty = false
        }

        this.loading = false
      })
    },
    refreshProjList() {
      return new Promise(resolve => {
        this.isAllProjLoaded = false
        this.currPage = 1
        this.projSource = undefined
        this.keywords = ''

        this.loading = true
        this.queryProjList().then(projList => {
          if (!projList.length) {
            this.isEmpty = true
          } else {
            this.projList = projList
            this.isEmpty = false
          }

          this.loading = false
          resolve()
        })
      })
    },
    handleScroll() {
      // 防止每次重新渲染都会触发滚动事件
      if (this.projList.length < this.pageSize) return

      if (this.isAllProjLoaded || this.keyWord) return
      this.currPage++
      this.queryProjList().then(projList => {
        if (projList.length) {
          this.projList = [...this.projList, ...projList]
        } else {
          this.isAllProjLoaded = true
        }
      })
    },
    viewProj(projInfo) {
      let defaultDataType = this.findDefaultDataType()
      let projectShareType = projInfo.projectShareType
      let projName = encodeURIComponent(projInfo.projName)

      if (projectShareType === 0) {
        if (!this.isChecked('Project.Single.Edit')) {
          this.$message.error('您没有编辑单项目的权限')
          return
        }
        let url = ''
        if (window.isStarRiver && this.isChecked('Project.Single.Scene.View')) {
          url = `/singleProject/panoramicDisplay/${projInfo.projId}`
        } else {
          url = `/singleProject/dataManage/${projInfo.projId}`
        }
        if (projName) {
          url = `${url}/${projName}?dataType=${defaultDataType}`
        } else {
          url = `${url}?dataType=${defaultDataType}`
        }
        this.$router.push(url)
      }

      if (projectShareType === 1) {
        let url = `/singleProject/sharedSceneList/${projInfo.projId}`
        if (projName) {
          url = `${url}/${projName}`
        }

        this.$router.push(url)
      }

      if (projectShareType === 2) {
        let params = { resourceId: projInfo.projId }
        getDemoProjTokenService(params).then(response => {
          if (response.isSuccess) {
            let token = response.data
            let oldToken = sessionStorage.getItem('token')
            TokenManager.setToken(token, 'sampleProject')
            sessionStorage.setItem('oldToken', oldToken)
            sessionStorage.setItem('token', token)
            this.getUserPermission().then(() => {
              let url
              // prettier-ignore
              if (window.isStarRiver && this.isChecked('Project.Single.Scene.View')) {
                url = `/singleProject/panoramicDisplay/${projInfo.projId}/${projName}?dataType=${defaultDataType}`
                sessionStorage.setItem('isDemoProj', true)
              } else {
                url = `/singleProject/dataManage/${projInfo.projId}/${projName}?dataType=${defaultDataType}`
              }
              this.$router.push(url)
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    deleteProjConfirm(projId, e) {
      e && e.stopPropagation()
      this.refreshToken().then(() => {
        this.$confirm('确定删除该项目?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.openNameValidateDialog(projId)
          })
          .catch(() => {
            // this.$message.info('取消删除!')
          })
      })
    },
    submitDelete() {
      let find = this.projList.find(el => el.projId === this.projIdToDelete)

      if (find.projName !== this.projNameInput) {
        this.projNameInput = ''
        this.$message.error('名称不一致，请重新输入！！！')
        return
      }

      deleteProjService(this.projIdToDelete, this.projNameInput).then(
        response => {
          if (response.isSuccess) {
            this.refreshProjList().then(() => {
              this.$message.success('删除成功!')

              this.projIdToDelete = ''
              this.projNameInput = ''
              this.isNameValidateDialogVisible = false
            })
          } else {
            this.$message.error(response.errMsg)
          }
        }
      )
    },
    openCreateProjDialog() {
      this.isCreateProjDialogVisible = true
    },
    closeCreateProjDialog() {
      this.isCreateProjDialogVisible = false
    },
    openNameValidateDialog(projId) {
      this.projIdToDelete = projId
      this.isNameValidateDialogVisible = true
    },
    closeNameValidateDialog() {
      this.projNameInput = ''
      this.projIdToDelete = ''
      // this.$message.info('取消删除!')
      this.isNameValidateDialogVisible = false
    },
    queryProjList() {
      return new Promise(resolve => {
        let params = {
          projName: this.keywords,
          shareType: this.projSource,
          resultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }
        getProjListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let projList = data.items
            let projTotal = data.totalCount
            this.projTotal = projTotal
            resolve(projList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    refreshToken() {
      return new Promise(resolve => {
        let oldToken = sessionStorage.getItem('oldToken')
        if (oldToken) {
          refreshTokenService({ token: oldToken }).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                sessionStorage.setItem('token', oldToken)
                sessionStorage.removeItem('oldToken')
                sessionStorage.removeItem('isDemoProj')
              } else {
                sessionStorage.removeItem('oldToken')
                sessionStorage.removeItem('isDemoProj')
                this.$message({
                  message: '登录信息已过期，请重新登录!',
                  type: 'error',
                  duration: 3 * 1000
                })
                if (window.isCloseTab) {
                  exitSystem()
                } else {
                  if (window.isPrivate) {
                    this.$router.push('/privateLogin')
                  } else {
                    this.$router.push('/login')
                  }
                  window.location.reload()
                }
              }
            }
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    getProjThumbnail(projInfo) {
      // prettier-ignore
      return `${window.imageBaseUrl}/${projInfo.thumbnail}?token=${getTokenId()}`;
    },
    getUpdateTime(projInfo) {
      let updateTime = ''
      if (projInfo.lastModificationTime) {
        updateTime = formatTime(projInfo.lastModificationTime)
      } else {
        updateTime = formatTime(projInfo.creationTime)
      }
      return updateTime
    },
    getDefaultThumbnail() {
      const themeName = this.$theme.get().value
      let thumbnail
      switch (themeName) {
        case 'stellar-light':
          thumbnail = require('@/assets/img/proj_default_img_light.png')
          break
        case 'dark':
          thumbnail = require('@/assets/img/proj_default_img_dark.png')
          break
      }
      return thumbnail
    },
    showDefaultImg(img) {
      const themeName = this.$theme.get().value
      switch (themeName) {
        case 'stellar-light':
          img.target.src = require('@/assets/img/proj_default_img_light.png')
          break
        case 'dark':
          img.target.src = require('@/assets/img/proj_default_img_dark.png')
          break
      }
    },
    isNoFindProj() {
      let isNoFind = false
      if (this.projSource !== undefined || !this.keywords) {
        if (this.projTotal === 0) {
          isNoFind = true
        }
      }
      return isNoFind
    },
    findDefaultDataType() {
      let defaultDataType = ''
      let permissionData = Store.permissionData
      for (let i = 0; i < dataTypeList.length; i++) {
        let permissionCode = dataTypeList[i].permissionCode
        let dataType = dataTypeList[i].id
        let find = permissionData.find(
          el => el.permissionCode === permissionCode
        )
        if (find.isCheck) {
          defaultDataType = dataType
          break
        }
      }
      return defaultDataType
    },
    getUserPermission() {
      return new Promise(resove => {
        let params = { menuName: '' }
        getRoleMenu(params).then(res => {
          if (res.status === 200) {
            let data = res.data
            if (data.isSuccess) {
              let permissionData = data.data
              permissionData = this.treeToList(permissionData)
              Store.permissionData = permissionData
              resove()
            } else {
              this.refreshToken()
              this.$message.error(data.errMsg)
            }
          } else {
            this.refreshToken()
          }
        })
      })
    },
    treeToList(permissionData) {
      let queue = []
      let out = []
      queue = queue.concat(permissionData)
      while (queue.length) {
        let first = queue.shift()
        if (first.childNodes) {
          queue = queue.concat(first.childNodes)
          delete first['childNodes']
        }
        out.push(first)
      }
      return out
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  },
  beforeDestroy() {
    EventBus.$off('getSubInfo')
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.proj-manage-box {
  height: 100%;
  background: var(--page-bgColor);
  padding-top: 1px;
  transition: all 0.3s;

  .expiredTitle {
    height: 48px;
    background: #fff6f1;
    border-radius: 16px 16px 16px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    font-weight: 400;
    font-size: 14px;
    color: #e37318;
    margin: 0 16px;
    margin-top: 8px;
    .el-icon-warning {
      margin-right: 8px;
    }
    &-link {
      font-weight: 500;
      font-size: 14px;
      color: #2580ff;
      margin: 0 8px;
      cursor: pointer;
    }

    .el-icon-close {
      color: #e37318;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .header-box {
    font-size: 14px;
    color: var(--primary-color);
    text-align: left;
    padding: 16px 0 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-left: 16px;
    margin-right: 5px;

    .operation-box {
      display: flex;
      justify-content: flex-end;
      color: var(--base-dark1-color);

      .item-box {
        display: flex;
        align-items: center;

        .common-button-box {
          margin-right: 16px;
        }

        .common-select-box {
          text-align: left;
        }
      }
    }

    .title-box {
      display: inline-block;
      line-height: 40px;
      border-bottom: 2px solid var(--primary-color);
    }
  }

  .proj-list-box {
    height: calc(100% - 68px);
    overflow-y: auto;
    padding-right: 16px;
    padding-bottom: 24px;

    .data-box {
      height: 100%;
      overflow: hidden;

      .list-box {
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        overflow-y: auto;
        align-content: flex-start;
        margin-left: 16px;
        gap: 16px;

        @media (max-width: 1660px) {
          .list-item-box {
            flex-basis: calc(25% - 16px * 4 / 5);
            /* 调整间距 */
          }
        }

        @media (min-width: 1660px) {
          .list-item-box {
            flex-basis: calc(20% - 16px * 4 / 5);
            /* 调整间距 */
          }
        }

        .list-item-box {
          position: relative;
          background: var(--home-content-list-bgColor);
          box-shadow: var(--home-content-list-box-shaow);
          border: 1px solid var(--home-content-list-border-color);
          border-radius: 16px;
          cursor: pointer;
          // flex: 0 0 calc(20% - 16px * 4 / 5);
          box-sizing: border-box;
          padding: 16px 16px 20px 16px;
          overflow: hidden;

          &:nth-child(5n) {
            margin-right: 0;
          }

          .time-info-box {
            width: 100%;
            height: 100%;
            background-color: var(--base-bg-dark-color7);
            border-radius: 6px;
            display: none;
            position: absolute;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            color: var(--base-light-color25);

            &-text {
              position: absolute;
              bottom: 16px;
              left: 16px;
              color: var(--aside-bg-color);
            }
          }

          .thumbnail-box {
            width: 100%;
            height: 180px;
            position: relative;
            border-radius: 6px;
            overflow: hidden;

            &:hover {
              .delete-btn-box {
                display: block;
              }

              .time-info-box {
                display: block;
                transition: all 0.3s;
              }
            }

            img {
              width: 100%;
              height: 100%;
              // object-fit: fill;
              border-radius: 4px 4px 0px 0px;
            }
          }

          .delete-btn-box {
            display: none;
            position: absolute;
            top: 0px;
            right: 0px;
            margin: 5px;

            .el-button {
              color: var(--base-dark2-color);
              width: 20px;
              height: 20px;
              padding: 0px;
              background: var(--base-dark3-color);

              &:hover {
                background: var(--base-dark3-color);
              }
            }
          }

          .symbol-box {
            position: absolute;
            display: flex;
            width: 81px;
            height: 18px;
            top: 11px;
            left: -18px;
            transform: rotate(-45deg);

            .text-box {
              color: var(--aside-bg-color);
              font-size: 12px;
              font-weight: 400;
              width: 100%;
              text-align: center;
            }
          }

          .share {
            background: var(--base-bg-light-color32);
          }

          .demo {
            background: var(--base-primary-bgColor);
          }

          .proj-info-box {
            text-align: left;
            // padding: 15px;
            // border-top: 1px solid var(--base-border-dark-color1);

            .text-overflow {
              color: var(--home-content-list-text-color);
              font-size: 16px;
              font-weight: 400;
              margin-top: 24px;
              margin-bottom: 4px;
              position: relative;
              overflow: visible;

              .base-name {
                color: var(--home-content-list-text-color);
                display: block;
                max-width: calc(100% - 34px);
                overflow: hidden;
                text-overflow: ellipsis;

                &.base-name-box {
                  cursor: default;

                  span {
                    cursor: pointer;
                  }
                }
              }

              .dropSelect {
                position: absolute;
                right: 0;
                bottom: -5px;

                .el-dropdown-link {
                  display: inline-block;
                  transform: rotate(90deg);

                  &:hover {
                    color: var(--home-content-list-text-color);
                    background-color: var(--home-content-list-icon-btn-bgColor);
                  }
                }

                // :deep(.el-icon) {
                //   color: var(--home-content-list-dropdown-color);
                // }
              }
            }

            .location-info-box {
              display: flex;
              // margin-top: 5px;
              color: var(--home-content-list-text-color);
              font-size: 14px;
              font-weight: 400;

              .city-name {
                color: var(--home-content-list-text-color);
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.dropSelect-item .el-dropdown-menu__item {
  padding-right: 8px;

  .el-button {
    width: 100%;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
